import { render, staticRenderFns } from "./roundedButton.vue?vue&type=template&id=09eef34e&scoped=true&"
import script from "./roundedButton.vue?vue&type=script&lang=js&"
export * from "./roundedButton.vue?vue&type=script&lang=js&"
import style0 from "./roundedButton.vue?vue&type=style&index=0&id=09eef34e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09eef34e",
  null
  
)

export default component.exports